import React from 'react';
import './FaultFirstPage/FaultFirstPageCustom.css'
import DashboardMain from '../DashboardMain/DashboardMain';
import FaultFirstPageCharts from './FaultFirstPage/FaultFirstPageCharts';
import FaultFirstPageDataBars from './FaultFirstPage/FaultFirstPageDataBars';
import FaultFirstPageFilters from './FaultFirstPage/FaultFirstPageFilters';
import FaultFirstPageKpis from './FaultFirstPage/FaultFirstPageKpis';
import FaultFirstPageBarChart from './FaultFirstPage/FaultFirstPageBarChart';
import { useCallback, useContext, useEffect, useState } from "react";
import moment from 'moment';
import { INIT_FILTER_STATE } from '../../../constants/driveglobalfilterinitalstates';
import { API_URL_MAIN } from '../../../constants/driveglobalfilterinitalstates';
import useHttp from '../../../hook/use-http'
import AppContext from '../../../store/AppContext';
import Faultanalysis from './Faultanalysis';

export default function FaultPage() {
  const [gloablfilter, setGloablfilter] = useState(INIT_FILTER_STATE)
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const app_ctx = useContext(AppContext);
  const log_data = (data) => {
  }

  useEffect(() => {
    fetchData({
      url: API_URL_MAIN + "auth/logging", body: {
        page_name: "faultanalysis"
      }
    }, log_data)
  }, []);

  const filterSubmited = useCallback((data) => {
    setGloablfilter(data);
  }, []);

  const singleVinSelected = (vin) => {
    let vin_num = vin.split(",");
    setGloablfilter((prevdata) => { return { ...prevdata, VIN_NUM: vin_num, pageSelected: 2 } });
  }

  const pageChange = () => {
    setGloablfilter((prevdata) => {
      return { ...prevdata, pageSelected: 1, VIN_NUM: [] }
    });
  }

  const onreset = (data) => {
    setGloablfilter(data);
  }

  if (gloablfilter.pageSelected === 1) {
    return (
      <>
        <DashboardMain>
          <FaultFirstPageFilters onsubmit={filterSubmited} gloablfilter={gloablfilter} onreset={onreset} />
          <div className="container-fluid">
            <FaultFirstPageKpis gloablfilter={gloablfilter} />
            <section className="graphs sec2Charts">
              <FaultFirstPageDataBars singleVinSelected={singleVinSelected} gloablfilter={gloablfilter} />
              <div className="row mt-4 mb-3">
                <FaultFirstPageCharts gloablfilter={gloablfilter} />
                <FaultFirstPageBarChart gloablfilter={gloablfilter} />
              </div>
            </section>
          </div>
        </DashboardMain>
      </>
    );
  } else {
    return (
      <DashboardMain>
        <Faultanalysis gloablfilter={gloablfilter} pageChange={pageChange} />
      </DashboardMain>
    );
  }
}